import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { QuestionCard } from './components/QuestionCard';
import { QuestionReviewContent } from './components/QuestionReviewContent';
import { Container, CardContent, Description } from './ReviewPreview.styles';

import reviewMode from '@/assets/review_mode.svg';
import { FullPageLoader } from '@/components/Loaders';
import { PagePaddingContainer } from '@/components/PagePaddingContainer';
import { PageTitle } from '@/components/PageTitle';
import { useReviewQuestionsResume } from '@/store';

const { Text } = Typography;

export const ReviewPreview = () => {
  const { t } = useTranslation('StudentQuizTranslations');
  const { isLoading } = useReviewQuestionsResume();

  if (isLoading)
    return (
      <PagePaddingContainer>
        <FullPageLoader />
      </PagePaddingContainer>
    );

  return (
    <PagePaddingContainer>
      <Container>
        <PageTitle showBackButton title={t('REVIEW_MODE_TITLE')} />
        <Description>
          <Text>{t('REVIEW_MODE_DESCRIPTION')}</Text>
          <img src={reviewMode} alt="review mode" />
        </Description>
        <CardContent>
          <QuestionReviewContent />
          <QuestionCard />
        </CardContent>
      </Container>
    </PagePaddingContainer>
  );
};
